export class Handover {
  id: string = "00000000-0000-0000-0000-000000000000";
  createdBy: string = "00000000-0000-0000-0000-000000000000";
  handoverFrom: string = "00000000-0000-0000-0000-000000000000";
  handoverTo?: string = "";
  location: string = "00000000-0000-0000-0000-000000000000";
  position: string = "00000000-0000-0000-0000-000000000000";
  creatorNote: string = "";
  receiverNote: string = "";
  state: number = 0;
  createdTime: Date = new Date();
  createdTimeString: Date = new Date();
}

export class HandoverExtended extends Handover {
  handoverFromFullName: string = "";
  handoverFromEmail: string = "";
  handoverToFullName: string = "";
  handoverToEmail: string = "";
  locationName: string = "";
  positionName: string = "";
}